module.exports = __webpack_public_path__ + "media/images/icons/dropdown_pink-fdd084d7cc2f856447c8fa33e18f9131.svg";